<template>
<div>
  <topbar></topbar>
  <search-bar></search-bar>
  <nav-bar></nav-bar>
  <router-view />
  <footer-bar></footer-bar>
</div>


</template>

<script>
import Topbar from "../top/topbar";
import SearchBar from "../search/searchBar";
import NavBar from "../nav/navBar";
import footerBar from "../footer/footerBar";
export default {
  name: "mainBar",
  components: {footerBar, NavBar, SearchBar, Topbar}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/mainbar.vue